import React from "react";
import "./DatePicker.css";

const DatePicker = ({
  label,
  value,
  onChange,
  min,
  max,
  disabled = false,
  className = "",
  size = 'md', // sm, md, lg
  inputStyle = {}, // input style
  labelStyle = {}, // label style
  inputId = "date-picker",
}) => {

  const getSizeClass = () => {
    switch (size) {
      case "sm":
        return "date-input-sm";
      case "lg":
        return "date-input-lg";
      default:
        return "date-input-md";
    }
  };

  return (
    <div className={`date-picker-container ${className}`}>
      {label && (
        <label htmlFor={inputId} style={{ ...labelStyle }}>
          {label}
        </label>
      )}
      <input
        type="date"
        id={inputId}
        className={`date-input ${getSizeClass()}`}
        value={value}
        onChange={onChange}
        min={min}
        max={max}
        disabled={disabled}
        style={{ ...inputStyle }}
      />
    </div>
  );
};

export default DatePicker;
